const basicShapes = require('../modules/shapelib/basic.json');

function ShapesFactory () {
  _.bindAll(this, 'initialize', 'getCategories', 'get');

  this.categories = [
    { key: 'basic', icon: 'fa fa-square-o' },
    { key: 'animal', icon: 'fa fa-bug' },
    { key: 'arrow', icon: 'fa fa-arrows' },
    { key: 'dialog_balloon', icon: 'fa fa-comments-o' },
    { key: 'electronics', icon: 'fa fa-microphone' },
    { key: 'flowchart', icon: 'fa fa-sitemap' },
    { key: 'game', icon: 'fa fa-gamepad' },
    { key: 'math', icon: 'fa fa-superscript' },
    { key: 'misc', icon: 'fa fa-fire-extinguisher' },
    { key: 'music', icon: 'fa fa-music' },
    { key: 'object', icon: 'fa fa-lightbulb-o' },
    { key: 'symbol', icon: 'fa fa-plus-square-o' },
    { key: 'web', icon: 'fa fa-rss' }
  ];
}

ShapesFactory.prototype = _.extend({}, Backbone.Events);

ShapesFactory.prototype.initialize = _.memoize(function () {
  const deferred = $.Deferred();
  const translate = INKIVE.TranslateHelper.translate;

  INKIVE.TranslateHelper.load().then(_.bind(function () {
    this.data = { basic: this.mapResult('basic', basicShapes) };

    _.each(this.categories, function (category) {
      category.name = translate('shapes.category.' + category.key);
    });

    deferred.resolve();
  }, this));

  return deferred.promise();
});

ShapesFactory.prototype.getCategories = function () {
  const deferred = $.Deferred();

  this.initialize().then(_.bind(function () {
    deferred.resolve(this.categories);
  }, this));

  return deferred.promise();
};

ShapesFactory.prototype.get = function (categoryId, shapeId) {
  const deferred = $.Deferred();
  categoryId = typeof categoryId === 'undefined' ? 0 : categoryId;

  this.getCategories().then(_.bind(function (categories) {
    const category = categories[categoryId] || _.find(categories, { key: categoryId });
    this._getCategory(category).then(function (shapes) {
      const isAskingForAll = typeof shapeId === 'undefined';

      isAskingForAll && deferred.resolve(shapes);
      if (!isAskingForAll) {
        const shape = shapes[shapeId] || _.find(shapes, { key: shapeId });
        deferred.resolve(shape);
      }
    });
  }, this));

  return deferred.promise();
};

ShapesFactory.prototype._getCategory = function (category) {
  const deferred = $.Deferred();
  const url = INKIVE.C.BASE_URL +
    'assets/js/editor/modules/shapelib/' +
    category.key + '.json';

  this.data[category.key] && deferred.resolve(this.data[category.key]);
  this.data[category.key] || $.getJSON(url, _.bind(function (result) {
    this.data[category.key] = this.mapResult(category.key, result);
    deferred.resolve(this.data[category.key]);
  }, this));

  return deferred.promise();
};

ShapesFactory.prototype.mapResult = function (categoryKey, result) {
  const translate = INKIVE.TranslateHelper.translate;

  return _.map(result.data, function (obj) {
    return _.extend({
      fill: result.fill || false,
      size: result.size || 300
    }, obj);
  });
};

module.exports = new ShapesFactory();
